export default __webpack_public_path__ + "static/media/app_podchaser.9318f285.svg";